var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 36,
    viewBox: "0 0 210 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.095 11.124C19.7072 11.124 18.7352 15.2928 18.7352 15.2928V27.351L0.97998 35.1486L21.014 0L41.3666 35.2782L23.4386 27.3672V15.309C23.4386 15.309 22.4666 11.1402 21.0788 11.1402",
    fill: "#1B2546"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M81.6236 8.79102L73.9502 26.449H75.6944L82.5794 10.4542H83.06L87.2558 20.1958H79.9658L79.3124 21.7078H87.9038L89.945 26.449H91.6892L84.0158 8.79102H81.6236Z",
    fill: "#1B2546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M102.208 24.7858H101.603L95.091 8.79102H93.3252L100.621 26.449H103.191L110.459 8.79102H108.742L102.208 24.7858Z",
    fill: "#1B2546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M117.015 8.79102H115.428V26.449H117.015V8.79102Z",
    fill: "#1B2546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M129.376 8.79102L121.708 26.449H123.447L130.337 10.4542H130.818L135.008 20.1958H127.718L127.07 21.7078H135.662L137.703 26.449H139.442L131.774 8.79102H129.376Z",
    fill: "#1B2546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M140.829 10.303H147.719V26.449H149.307V10.303H156.219V8.79102H140.829V10.303Z",
    fill: "#1B2546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M163.158 8.79102H161.571V26.449H163.158V8.79102Z",
    fill: "#1B2546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M183.127 9.67648C181.707 8.92048 180.136 8.54248 178.424 8.54248C176.712 8.54248 175.184 8.92048 173.758 9.67648C172.327 10.4325 171.199 11.5071 170.367 12.8949C169.535 14.2827 169.12 15.8595 169.12 17.6253C169.12 19.3911 169.535 20.9679 170.367 22.3557C171.199 23.7435 172.333 24.8127 173.758 25.5741C175.189 26.3301 176.744 26.7081 178.424 26.7081C180.103 26.7081 181.707 26.3301 183.127 25.5741C184.547 24.8181 185.681 23.7435 186.518 22.3557C187.361 20.9679 187.782 19.3911 187.782 17.6253C187.782 15.8595 187.361 14.2827 186.518 12.8949C185.676 11.5071 184.547 10.4379 183.127 9.67648ZM185.12 21.5727C184.423 22.7229 183.489 23.6139 182.317 24.2457C181.151 24.8775 179.849 25.1907 178.418 25.1907C176.987 25.1907 175.713 24.8775 174.536 24.2457C173.359 23.6139 172.424 22.7229 171.733 21.5727C171.042 20.4225 170.696 19.1049 170.696 17.6253C170.696 16.1457 171.042 14.8281 171.733 13.6779C172.424 12.5277 173.359 11.6367 174.536 11.0049C175.713 10.3731 177.009 10.0599 178.418 10.0599C179.828 10.0599 181.145 10.3731 182.317 11.0049C183.484 11.6367 184.418 12.5277 185.12 13.6779C185.816 14.8281 186.167 16.1457 186.167 17.6253C186.167 19.1049 185.816 20.4225 185.12 21.5727Z",
    fill: "#1B2546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M207.433 8.79102V24.6616H206.849L196.535 8.79102H193.76V26.449H195.347V10.5838H195.931L206.245 26.449H209.02V8.79102H207.433Z",
    fill: "#1B2546"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M51.4212 19.5965C50.6976 19.5965 50.0982 19.4507 49.6122 19.1537C49.1316 18.8567 48.7698 18.4679 48.5268 17.9765C48.2892 17.4905 48.1704 16.9451 48.1704 16.3457H49.3152C49.3152 16.7507 49.3908 17.1179 49.5366 17.4473C49.6824 17.7767 49.9146 18.0359 50.2332 18.2303C50.5464 18.4301 50.946 18.5273 51.4212 18.5273C52.0746 18.5273 52.566 18.3599 52.9008 18.0251C53.2356 17.6903 53.403 17.2853 53.403 16.8209C53.403 16.3565 53.2842 15.9569 53.052 15.6329C52.8198 15.3089 52.4526 15.0497 51.9558 14.8553L50.4762 14.2937C49.9902 14.0993 49.5906 13.8779 49.2774 13.6241C48.9642 13.3703 48.7374 13.0571 48.5808 12.6953C48.4296 12.3281 48.354 11.8907 48.354 11.3831C48.354 10.9025 48.4782 10.4597 48.7266 10.0493C48.975 9.6389 49.3314 9.30411 49.785 9.05571C50.244 8.80731 50.7732 8.68311 51.3726 8.68311C52.0152 8.68311 52.5714 8.8235 53.0412 9.1097C53.511 9.3959 53.8728 9.7847 54.1158 10.2761C54.3588 10.7675 54.483 11.3237 54.483 11.9339H53.3382C53.3382 11.5397 53.2626 11.1725 53.1114 10.8431C52.9602 10.5137 52.7334 10.2491 52.4418 10.0493C52.1448 9.8495 51.7884 9.7523 51.3726 9.7523C50.8056 9.7523 50.3466 9.9143 50.0064 10.2383C49.6662 10.5623 49.4934 10.9457 49.4934 11.3831C49.4934 11.8637 49.6014 12.2471 49.8228 12.5441C50.0442 12.8411 50.3898 13.0787 50.8704 13.2623L52.1502 13.7483C52.7118 13.9643 53.1654 14.2073 53.5164 14.4827C53.8674 14.7581 54.1266 15.0875 54.294 15.4655C54.4614 15.8435 54.5478 16.3025 54.5478 16.8317C54.5478 17.3609 54.4236 17.8037 54.1806 18.2303C53.9376 18.6569 53.5812 18.9863 53.1114 19.2347C52.6416 19.4831 52.08 19.6073 51.4158 19.6073L51.4212 19.5965Z",
    fill: "#1B2546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M56.686 19.4722V8.79102H57.8308V13.5538H62.2588V8.79102H63.4036V19.4722H62.2588V14.6176H57.8308V19.4722H56.686Z",
    fill: "#1B2546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M67.929 19.4722V15.5788L64.77 8.78564H66.0228L68.388 13.975H68.6148L70.98 8.78564H72.2328L69.0738 15.5788V19.4722H67.929Z",
    fill: "#1B2546"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.946fa3aa2c66084f5cbf39c9ac240838.svg";
export { ForwardRef as ReactComponent };